<template>
  <div>

    <page-heading-info
    title="Jefferson County Juvenile Court"
    phone="(740) 283-8557"
    fax="(740) 283-8694"
    hours="8:30AM to 4:30PM"
    pobox="PO Box 549"
    floor="4th floor"
    >
      <address-simple
      line1="16001 State Route 7"
      line2="PO Box 549"
      line3="Steubenville, OH 43952"
      ></address-simple>
    </page-heading-info>

    <text-box-title title="General Info">
      <div class="col-md-6 mt-3">
        <p>
          The Juvenile Court has jurisdiction over all delinquent children, issues of parentage,
          custody, child support, dependency, and truancy. The court provides several programs
          year round which are felt to accurately represent this vision.
        </p>
        <p>
          These programs all represent the court's efforts aimed at recognizing at-risk youth and 
          matters involving abused, neglected, or dependent children, unruly and intervening with them 
          in an appropriate manner, while striving to keep the family unit intact whenever possible.
        </p>
      </div>
      <div class="col-md-6 mt-3">
        <link-box
        bg-color="dark"
        dark="true"
        icon="payment"
        icon-color="light"
        title-color="light"
        title="Make a Payment"
        title-align="left"
        url="https://client.pointandpay.net/web/JeffersonCountyJuvenileCourtOH">
          Click here to pay juvenile court bills
        </link-box>
      </div>
    </text-box-title>

    <!-- PROGRAMS ///////////////////////////////////////////////////////////////////////////////// -->
    <text-box-title title="Programs">
      <div class="col-md-6 mt-3">
          <icon-title
          title="P.R.I.D.E"
          icon="group_work"
          underline="true"
          ></icon-title>
          <p>
            Positive Reinforcement of Inner Determination and Endurance provides youth the structure to better 
            themselves both mentally and physically. P.R.I.D.E. is typically ordered to delinquent and unruly 
            children as an avenue to learn self-respect, self-discipline and self-motivation.
          </p>
          <p>
            <a href="/static/departments/probate_court/PROBATE-COURT-RECORDS-INFO.pdf">
              P.R.I.D.E Schedule
            </a>
          </p>  
      </div>

      <div class="col-md-6 mt-3">
          <icon-title
          title="Community Service"
          icon="public"
          underline="true"
          ></icon-title>
          <p>
            The Court takes pride in projects consist of promoting restoration and beautification within 
            Jefferson County. These projects consist of litter pick-ups along the counties roadways and parks, recycling,
            tree planting, public school clean-ups, and active participation with the Annual Jefferson County Fair. 
          </p>
          <p>
            <a href="/static/departments/probate_court/PROBATE-COURT-RECORDS-INFO.pdf">
              Community Service Schedule
            </a>
          </p>  
      </div>

      <div class="col-md-6 mt-3">
          <icon-title
          title="Alternative School"
          icon="school"
          underline="true"
          ></icon-title>
          <p>
            The program provides a more controlled academic setting for youth who are in danger of being suspended or expelled 
            from their home school, those having truancy issues, and/or are having other school related problems which lend themselves
            to an alternative approach in their education.
          </p> 
      </div>
    </text-box-title>


    <!-- SPECIALIZED DOCKET ////////////////////////////////////////////////////////////////////// -->
    <text-box-title title="Specialized Docket">
      <div class="col-md-4 mt-3">
          <icon-title
          title="Mediation"
          icon="info"
          underline="true"
          ></icon-title>
          <p>
            Mediation allows parties to directly discuss important issues
            and work toward a resolution that parties believe is in their
            best interest rather than having a Judge decide for them.
          </p> 
      </div>

      <div class="col-md-4 mt-3">
          <icon-title
          title="Drug Court"
          icon="info"
          underline="true"
          ></icon-title>
          <p>
            The Jefferson County Juvenile Court Drug Court is a
            Court-managed, drug intervention treatment program
            designed to provide a cost-effective alternative to
            traditional criminal case processing.   
          </p> 
      </div>

      <div class="col-md-4 mt-3">
          <icon-title
          title="Traffic Court"
          icon="info"
          underline="true"
          ></icon-title>
          <p>
            Effective since 2005, the Traffic Court Program is a
            court-managed sanction incentive program that identifies
            first time and repeat juvenile traffic offenders.
          </p> 
      </div>
    </text-box-title>
    
    <!-- Downloadable documents todo: make this dynamic at some point -->
    <text-box-title title="Documents &amp; Forms">
      <div class="col-md-6 mt-3">
        <ul class="list-group list-group-flush">
          
          <li class="list-group-item">
            <a href="/static/departments/juvenile_court/Comm_Service_Verify.pdf">
              Community Service Verification Form
            </a>
          </li>

          <li class="list-group-item">
            <a href="/static/departments/juvenile_court/Juvenile-Court-Costs.pdf">
              Court Costs
            </a>
          </li>

          <li class="list-group-item">
            <a href="/static/departments/juvenile_court/Juvenile-Local-Rules.pdf">
              Local Rules
            </a>
          </li>

          <li class="list-group-item">
            <a href="/static/departments/juvenile_court/Local_Parenting_Guidelines.pdf">
              Local Parenting Guidelines
            </a>
          </li>

          <li class="list-group-item">
            <a href="/static/departments/juvenile_court/Long_Distance_Guidelines.pdf">
              Long Distance Parenting Guidelines
            </a>
          </li>

        </ul>
      </div>

      <div class="col-md-6 mt-3">
        <ul class="list-group list-group-flush ">
          
          <li class="list-group-item">
            <a href="/static/departments/juvenile_court/Motion_For_Visitation.pdf">       
              Motion/Petition for Visitation
            </a>
          </li>

          <li class="list-group-item">
            <a href="/static/departments/juvenile_court/Magistrate_Objection.pdf">       
              Objection to Magistrate's Recommendations
            </a>
          </li>

          <li class="list-group-item">
            <a href="/static/departments/juvenile_court/Complaint_For_Custody.pdf">       
              Motion/Petition For Allocation or Reallocation of Parental Rights and Responsibilities (Custody)
            </a>
          </li>

          <li class="list-group-item">
            <a href="/static/departments/juvenile_court/Motion_For_Continuance.pdf">       
              Motion for Continuance
            </a>
          </li>

          <li class="list-group-item">
            <a href="/static/departments/juvenile_court/Motion_For_Contempt.pdf">       
              Motion for Contempt
            </a>
          </li>

          <li class="list-group-item">
            <a href="/static/departments/juvenile_court/Motion_For_Hearing.pdf">       
              Motion for Hearing
            </a>
          </li>

        </ul>
      </div>
    </text-box-title>

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import OfficeInfo from '@/components/layout/OfficeInfo.vue'
import AddressSimple from '@/components/display-utils/AddressSimple.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import IconTitle from '@/components/display-utils/IconTitle.vue'
import LinkBox from '@/components/layout/LinkBox.vue'

export default {
  components: {
    PageHeadingInfo,
    OfficeInfo,
    AddressSimple,
    TextBoxTitle,
    IconTitle,
    LinkBox
  },
  data () {
    return {}
  },
  created: function() {
  },
  methods: {
  }
}
</script>

<style scoped>
  .court-lookup {
    font-size: 1.5em;
    font-weight: bold;
  }

  .court-lookup:hover {
    opacity: 0.7;
  }

</style>
